export default [
  {
    path: "/Report/SummaryReport",
    name: "SummaryReport",
    component: () => import("@/components/Report/SummaryReport.vue"),
    meta: {
      title:'SummaryReport',
      menuTitle: "Summary Report",
      name: "SummaryReport",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Report/RecapReport",
    name: "RecapReport",
    component: () => import("@/components/Report/RecapReport.vue"),
    meta: {
      title:'RecapReport',
      menuTitle: "Recap Report",
      name: "RecapReport",
      requiresAuth: true,
    },
    props: true,
  },  
  {
    path: "/Report/StatisticalReport",
    name: "StatisticalReport",
    component: () => import("@/components/Report/StatisticalReport.vue"),
    meta: {
      title:'StatisticalReport',
      menuTitle: "Statistical Report",
      name: "StatisticalReport",
      requiresAuth: true,
    },
    props: true,
  },    
  {
    path: "/Report/EmployeeReport",
    name: "EmployeeReport",
    component: () => import("@/components/Report/EmployeeReport.vue"),
    meta: {
      title:'EmployeeReport',
      menuTitle: "Employee Report",
      name: "EmployeeReport",
      requiresAuth: true,
    },
    props: true,
  },  
  {
    path: "/Report/AppraisalReport",
    name: "AppraisalReport",
    component: () => import("@/components/Report/AppraisalReport.vue"),
    meta: {
      title:'AppraisalReport',
      menuTitle: "Appraisal Report",
      name: "AppraisalReport",
      requiresAuth: true,
    },
    props: true,
  },  
  {
    path: "/Report/WarningLetterReport",
    name: "WarningLetterReport",
    component: () => import("@/components/Report/WarningLetterReport.vue"),
    meta: {
      title:'WarningLetterReport',
      menuTitle: "Warning Letter Report",
      name: "WarningLetterReport",
      requiresAuth: true,
    },
    props: true,
  },  
  {
    path: "/Report/PerformanceReport",
    name: "PerformanceReport",
    component: () => import("@/components/Report/PerformanceReport.vue"),
    meta: {
      title:'PerformanceReport',
      menuTitle: "Performance Report",
      name: "PerformanceReport",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Report/PromotionReport",
    name: "PromotionReport",
    component: () => import("@/components/Report/PromotionReport.vue"),
    meta: {
      title:'PromotionReport',
      menuTitle: "Promotion Report",
      name: "PromotionReport",
      requiresAuth: true,
    },
    props: true,
  },  
];